module.exports = __webpack_public_path__ + "static/media/futura-condensed.0179f5fe.ttf";